import MuiDialog, { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import { Ref, useCallback, useImperativeHandle, useState } from 'react';

export type ICallableRef = {
    setOpen: (open: boolean) => void;
};

export type IDialogContainerProps = Omit<MuiDialogProps, 'open' | 'onClose'> & {
    innerRef?: Ref<ICallableRef>;
    open?: boolean;
    onClose?: () => void;
};

const StyledContainer = styled(MuiDialog)`
    .MuiDialog-container {
        align-items: flex-start;
        transform: translateY(10vh);
    }
`;

export const DialogContainer = ({ innerRef, open, onClose, ...props }: IDialogContainerProps) => {
    const [isOpen, setOpen] = useState<boolean | null>(open ?? false);

    const handleClose = useCallback(() => {
        setOpen(false);
        if (onClose && isOpen !== null) {
            onClose();
        }
    }, [isOpen]);

    useImperativeHandle(innerRef, () => ({
        setOpen: (newState) => {
            if (newState !== isOpen) {
                if (newState) {
                    setOpen(newState);
                } else {
                    setOpen(null);
                }
            }
        }
    }));

    return (
        <StyledContainer {...props} open={isOpen ?? false} onClose={handleClose}>
            {props.children}
        </StyledContainer>
    );
};
